'use client';

import RichText from '@/components/RichText';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import { ReactNode } from 'react';
import CustomRichText from '../CustomRichText';

export interface TxtBlockCustomV2Props {
  title: ReactNode | SerializedEditorState;
  content?: ReactNode | SerializedEditorState;
}

export default function TxtBlockCustomV2({ title, content }: TxtBlockCustomV2Props) {
  return (
    <div data-meta="TxtBlockCustomV2" className="my-14">
      <div className="container mx-auto px-4 py-6 sm:py-4 sm:px-6 lg:px-8">
        <div className="mx-auto text-center">
          <div className="text-3xl font-bold tracking-tight text-white sm:text-6xl mb-4 sm:mb-8">
            <CustomRichText data={title} tag="h2" />
          </div>
          {content && (
            <div className="mt-6 text-base lg:text-lg md:leading-6 lg:leading-8 text-white">
              <CustomRichText data={content} tag="div" className="" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
